
export enum Gender {
	Male = 'male',
	Female = 'female',
}
